import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Alert, AlertTitle, Card, Link, TextField } from '@mui/material';
import { AppCardSection, AppFormLayout, AppOptionList, AppTextStyle } from '@shared';

import { ta } from 'utils';
import axios from 'utils/axios-rails';

import BasicTextField from '@shared/BasicTextField';
import DatePicker from '@shared/AppDatePicker';
import TaskDeliveryDetails from './TaskDeliveryDetails';
import MovementRoute from 'components/shared/MovementRoute';

const propTypes = {
  // values: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
}

const defaultProps = {
  readOnly: false,
}

const TaskUpdateForm = ({ renderProps, ...props }) => {
  const [loading, setLoading] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [customerOrderItems, setCustomerOrderItems] = useState([]);
  
  const { values } = renderProps;
  const { kinds, teams } = props.catalogs;

  const orderDataExists = !!values.brightpearl_data.order_reference || !!values.brightpearl_data.order_items;

  return (
    <Card>
      <Alert severity="info">
        <AlertTitle sx={{ mb: 0 }}>{ I18n.t(`enum.status.${values.status}`) }</AlertTitle>
      </Alert>
      {/* Only sent for a task that belongs to an RMA the user can open, so there is never a dead link. */}
      { values.customer_ticket_link &&
        <AppCardSection title="RMA asociado">
          <Link href={ values.customer_ticket_link.url }>{ values.customer_ticket_link.name }</Link>
        </AppCardSection>
      }
      <AppCardSection title="Información de contacto">
        <AppFormLayout>
          <TextField
            fullWidth
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            label={ta("task.kind")}
            value={ I18n.t(`enum.kind.${values.kind}`) }
          />
          
          {/* Fields based on Contact selection */}
          <AppFormLayout.Group>
            <TextField
              fullWidth
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
              label={ta("general.name")}
              value={ values.brightpearl_data.name }
            />
            <TextField
              fullWidth
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
              label={ta("general.phone")}
              value={ values.brightpearl_data.phone }
              />
          </AppFormLayout.Group>
          <TextField
            fullWidth
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            label={ta("general.address")}
            value={ values.address }
          />
        </AppFormLayout>
      </AppCardSection>

      { orderDataExists ? (
        <AppCardSection title="Información de la tarea">
          <AppFormLayout>
            <TextField
              fullWidth
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
              label={ta("task.provider_order_id")}
              value={ String(values.provider_order_id) }
            />
            <AppFormLayout.Group>
              <TextField
                fullWidth
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                label="#"
                value={ values.brightpearl_data.order_reference }
              />
              <TextField
                fullWidth
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                label={ta("general.status")}
                value={ values.brightpearl_data.order_status }
              />
            </AppFormLayout.Group>
            { values.brightpearl_data.order_items.length > 0 &&
              <AppOptionList
                title="Productos"
                readOnly
                allowMultiple
                onChange={ () => true }
                options={ values.brightpearl_data.order_items }
                selected={ values.item_ids }
              />
            }
          </AppFormLayout>
        </AppCardSection>
        ) : ( null )
      }
          
      {/* An RMA move says where the courier picks the product up and drops it off; `address` alone cannot. */}
      { values.rma_route &&
        <AppCardSection title="Movimiento">
          {/* The route line is the one place that says where to pick up and drop off; the fields below only
              add what it cannot: who owns the case, who to call at the workshop and where the case stands. */}
          <AppFormLayout>
            <div>
              <AppTextStyle variation="strong">{ values.rma_route.leg_label }</AppTextStyle>
              <div className="mt4">
                <MovementRoute movement={ values.rma_route.leg } origin={ values.rma_route.origin } destination={ values.rma_route.destination } withLabels />
              </div>
            </div>
            { values.rma_route.supplier_leg &&
              <AppFormLayout.Group>
                {/* Only when it adds something: no supplier, or one that is the workshop itself, is already in the route */}
                { values.supplier_case_summary?.supplier && values.supplier_case_summary.supplier !== values.supplier_case_summary.workshop &&
                  <TextField
                    fullWidth
                    InputProps={{ readOnly: true }}
                    InputLabelProps={{ shrink: true }}
                    label="Proveedor del caso"
                    value={ values.supplier_case_summary.supplier }
                  />
                }
                <TextField
                  fullWidth
                  InputProps={{ readOnly: true }}
                  InputLabelProps={{ shrink: true }}
                  label="Contacto del taller"
                  value={ values.rma_route.contact || '—' }
                />
                <TextField
                  fullWidth
                  InputProps={{ readOnly: true }}
                  InputLabelProps={{ shrink: true }}
                  label="Gestión de Proveedor"
                  value={ values.supplier_case_summary?.status || '—' }
                />
              </AppFormLayout.Group>
            }
          </AppFormLayout>
        </AppCardSection>
      }

      <AppCardSection title="Información de envío">
        <TaskDeliveryDetails 
          initialCouriers={ props.initialCouriers }
          queryCouriersURL={ props.queryCouriersURL }
          teams={ teams }
          disabled={ props.readOnly }

          formProviderProps={ renderProps }
        />
      </AppCardSection>
    </Card>
  )
};

TaskUpdateForm.propTypes = propTypes;
TaskUpdateForm.defaultProps = defaultProps;

export default TaskUpdateForm;